import { Component, OnInit } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import {
  PERFORM_ACADEMIC_ROLLOVER,
  PERFORMED_ACADEMIC_ROLLOVER,
  ACADEMIC_ROLLOVER_FAILURE
} from "@reducers/contacts";

@Component({
  selector: 'academic-rollover-view',
  templateUrl: 'academic-rollover-view.pug',
})
export class AcademicRolloverViewComponent implements OnInit {

  constructor(
    private store: Store<AppState>,
    private actions: Actions
  ) {}

  public isConfirming: boolean = false
  public isLoading: boolean = false
  public isSuccessMessageVisible: boolean = false
  public isFailureMessageVisible: boolean = false

  ngOnInit() {
  }

  clickedRollover() {
    this.isConfirming = true
  }

  clickedConfirm() {
    this.isConfirming = false
    this.isLoading = true

    this.actions
      .ofType(PERFORMED_ACADEMIC_ROLLOVER, ACADEMIC_ROLLOVER_FAILURE)
      .take(1)
      .subscribe((a: Action) => {
        this.isLoading = false
        if (a.type == PERFORMED_ACADEMIC_ROLLOVER) {
          this.isSuccessMessageVisible = true
        }
        else if (a.type == ACADEMIC_ROLLOVER_FAILURE) {
          this.isFailureMessageVisible = true
        }
      })
    this.store.dispatch({ type: PERFORM_ACADEMIC_ROLLOVER })
  }

  clickedCancel() {
    this.isConfirming = false
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/academic-rollover-view.ts